/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { KeyboardEventHandler, KeyboardEvent } from 'react';
import { Alert } from '@ver-uds/uswds-react';

export type BulkUploadAlertProps = {
  openBulkUpload: () => void;
};
const BulkUploadAlert = ({ openBulkUpload }: BulkUploadAlertProps): JSX.Element => {
  const handleKeyDown: KeyboardEventHandler = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      openBulkUpload();
    }
  };
  return (
    <Alert status="info" slim>
      <Alert.Text>
        To expedite the number of hiring sites added, you may want to use&nbsp;
        <a
          className="cursor-pointer"
          onClick={openBulkUpload}
          onKeyDown={handleKeyDown}
          tabIndex={0}
          aria-label="Bulk Upload Link"
        >
          Bulk Upload.
        </a>
      </Alert.Text>
    </Alert>
  );
};
export default BulkUploadAlert;
